export enum TicketServices {
    CHAT = 1,
    SMS = 2,
    MAIL = 3,
    SOCIAL = 4,
    VIDEOCHAT = 5,
    TELEGRAM = 6,
    VIDEOCHAT_SCHEDULED = 10,
    VIDEOCHAT_MEDICI_SCHEDULED = 11,
    ECUTE_WEB_WIDGET = 18,
}
